import React, { useContext } from "react";
import Multipage_OurTeamContext from "../../../context/multipage_OurTeamContext/Multipage_OurTeamContext";
import OurTeamStyleOne from "./OurTeamStyleOne";
import {
  OurTeamTheme,
  THEME_UPDATE_MESSAGE,
  ThemeNo,
  ourTeamTheme1,
} from "../../../../constant";
import OurTeamStyleTwo from "./OurTeamStyleTwo";
import { Button, Col, Container, Row } from "reactstrap";
import {
  ourTeamStyleOneReset,
  ourTeamStyleTwoReset,
} from "./OurTeamStyleFunction";
import { TostMessage } from "../../../utils";
import LoaderContext from "../../../../context/LoaderContext/LoaderContext";
import { putUpdateOurTeam } from "../apis/OurTeamApi/OurTeamApi";
import OurTeamTheme1 from "../ScreenShorts/OurTeam/OurTeamTheme1.png";
import OurTeamTheme2 from "../ScreenShorts/OurTeam/OurTeamTheme2.png";
import ThemeImageShow from "../../../common/ThemeImageShow";

const SettingOurTeamPerentPopup = (props) => {
  const {
    setSettingFormData,
    setBoxSection,
    setBackImageToggle,
    setBoxSection1,
    setBackImageToggle1,
    setIsBackgroundColor,
    setIsBackgroundColor2,
    theme,
    setTheme,
    id,
    settingFormData,
    imgShow,
    setImgShow,
  } = useContext(Multipage_OurTeamContext);
  const { setLoaderShow } = useContext(LoaderContext);
  const { imageUpload, handleSubmitSetting, handleChangeSettings } = props;

  const resetHandler = () => {
    let setStyle;
    if (theme === ThemeNo.ThemeOne) {
      setStyle = ourTeamStyleOneReset;
    } else if (theme === ThemeNo.ThemeTwo) {
      setStyle = ourTeamStyleTwoReset;
    }
    setSettingFormData({ ...setStyle });
    setBackImageToggle(false);
    setBoxSection(false);
    setBackImageToggle1(false);
    setBoxSection1(false);
    setIsBackgroundColor(true);
    setIsBackgroundColor2(true);
  };
  const handleTheme = async (e) => {
    setLoaderShow(true);
    const { value } = e.target;
    setTheme(value);
    try {
      let formData = {
        theme: value,
        teamId: id,
      };
      const { data } = await putUpdateOurTeam(formData);
      if (data.status === 200) {
        await handleChangeSettings(id, true);
        TostMessage({
          message: { message: THEME_UPDATE_MESSAGE },
          type: "success",
        });
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
    } finally {
      setLoaderShow(false);
    }
  };
  const handleClose = () => {
    setImgShow(false);
  };
  const themeImg = {
    1: OurTeamTheme1,
    2: OurTeamTheme2,
  };
  return (
    <>
      <Container className="mb-5">
        <Row>
          <Col sm="12" xl="12">
            <div className="mt-4 d-flex flex-column justify-content-center position-relative">
              <div
                className="d-flex justify-content-between position-sticky"
                style={{ top: "87px", background: "white", zIndex: 999 }}
              >
                <h6>{"Edit"}</h6>
                <div className="d-flex gap-2">
                  <Button onClick={resetHandler}>Reset</Button>
                  <Button onClick={() => handleSubmitSetting(true)}>
                    Restore
                  </Button>
                  <Button
                    onClick={() => handleSubmitSetting(null, false)}
                    color="success"
                  >
                    Save & View
                  </Button>
                </div>
              </div>

              <Row>
                <Col>
                  <label htmlFor="">Theme</label>
                  <select
                    name="theme"
                    id="font-weight"
                    className="form-select"
                    value={theme}
                    onChange={(e) => handleTheme(e)}
                    style={{ borderRadius: "0", color: "black" }}
                  >
                    <option value={1}>Theme 1</option>
                    <option value={2}>Theme 2</option>
                  </select>
                </Col>
              </Row>
              {!imgShow && (
                <Button
                  onClick={() => setImgShow(true)}
                  color="primary"
                  className="mt-2"
                >
                  Show Theme Image
                </Button>
              )}
              {imgShow && (
                <ThemeImageShow
                  themeImg={themeImg[theme]}
                  handleClose={handleClose}
                />
              )}
              {+theme === OurTeamTheme.theme1 && (
                <OurTeamStyleOne
                  imageUpload={imageUpload}
                  handleSubmitSetting={handleSubmitSetting}
                />
              )}
              {+theme === OurTeamTheme.theme2 && (
                <OurTeamStyleTwo
                  imageUpload={imageUpload}
                  handleSubmitSetting={handleSubmitSetting}
                />
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default SettingOurTeamPerentPopup;
